import Vuex from "vuex";

const state = {
    detail: {},
    isLoad: false,
    whiteList: [
        "/install/list",
        "/install/detail",
        "/service/list",
        "/service/detail",
        "/course/index",
        "/course/detail",
        "/contract/index",
        "/contract/detail",
        "/script/list",
        "/material/list",
    ],
};

const mutations = {};

const getters = {};

const actions = {};

const store = () =>
    new Vuex.Store({
        state,
        getters,
        mutations,
        actions,
    });

export default store;


// WEBPACK FOOTER //
// ./src/vuex/store.js